// extracted by mini-css-extract-plugin
module.exports = {"leaders":"Leaders_leaders__JIndv"};